import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useHistory } from "react-router";
import { ElxContainer, ElxPrimaryButton, ElxSecondaryButton, } from "@elixir/components";
import { Checkbox, Link, Stack, Text } from "@fluentui/react";
import { useLocaleStrings } from "../../../library/providers/strings";
import { useCommercialContextDispatch } from "../../../reducers/CommercialContext/CommercialContextProvider";
import CustomHeader from "../../../commoncomponents/CustomHeader";
import "./Acknowledgement.styles.css";
const scenarios = [
    {
        header: "Volume Licensing/M365-Azure Billing",
        subHeader: "Our team manages scenarios including:",
        items: [
            {
                text: "Complex Volume Licensing provisioning issues where standard support channels have failed and issue does not fall under Post Sales Seller Support scope.",
                subText: ""
            },
            {
                text: "M365/Azure Billing issues - where GTFS/standard support channels have failed.",
                subText: ""
            },
            {
                text: "GCC HI/DOD provisioning issues - support for complex GCC billing and provisioning issues where standard support channels have failed.",
                subText: "*Please provide any existing Support case numbers in your submission"
            },
        ]
    },
    {
        header: "Licensing Documentation Errors",
        subHeader: "We support the following scenarios:",
        items: [
            {
                text: [_jsx("b", { children: "Translation errors:" }, "translation-label"), " These scenarios are escalated when the translation of a document from one language to another leads to inconsistencies in the licensing terms."],
                subText: ""
            },
            {
                text: [_jsx("b", { children: "Contradictions or inconsistencies in materials:" }, "contradictions-label"), " These scenarios occur when a published document is not consistent with another published."],
                subText: ""
            },
            {
                text: [_jsx("b", { children: "Mis-publications:" }, "mispublications-label"), " These scenarios deal with incorrect information, typos, or content from previous documentation that were not included in subsequent versions of documents."],
                subText: ""
            },
        ]
    },
    {
        header: "Licensing Navigator",
        subHeader: "(AI assisted answers to licensing questions)",
        items: [
            {
                text: ["For answers to licensing questions, please visit the AI based ", _jsx(Link, Object.assign({ href: "https://microsoft.sharepoint.com/teams/Commercial-Licensing/SitePages/Licensing-Navigator.aspx" }, { children: "License Navigator" }), "license-navigator-link"), " tool where you can submit your question and receive an answer with supporting material or submit a request to provide feedback for errors or missing information."],
                subText: ""
            },
        ]
    }
];
export const VLM365AzureAcknowledgementDetail = () => {
    const { getLocalSpecificString } = useLocaleStrings();
    const commercialContextDispatch = useCommercialContextDispatch();
    const [enableEscalationButton, setEnableEscalationButton] = useState(false);
    const history = useHistory();
    const onCreateEscalationClick = () => {
        commercialContextDispatch.updateEnableAcknowledgement(true);
    };
    const onCancel = () => {
        history.push("/");
    };
    function renderHeader() {
        return (_jsx(CustomHeader, { onCancel: onCancel, headerText: "Before creating an escalation", iconButtonText: "" }));
    }
    return (_jsx(ElxContainer, Object.assign({ headerContent: renderHeader(), fillBackground: true, className: "vlm365AzureAcknowledgementContainer" }, { children: _jsxs(Stack, Object.assign({ className: "vlm365AzureAcknowledgementContent" }, { children: [_jsx(Stack.Item, Object.assign({ styles: { root: { height: "100%" } } }, { children: _jsxs(Stack, Object.assign({ styles: {
                            root: {
                                maxWidth: "45.5rem",
                                paddingLeft: "1rem",
                                paddingRight: "1rem"
                            },
                        }, tokens: { childrenGap: 15 } }, { children: [_jsx(Stack.Item, { children: _jsx("ul", { children: scenarios.map((scenario, index) => (_jsxs("li", Object.assign({ className: "no-dot scenario-item" }, { children: [_jsx("h3", { children: scenario.header }), _jsx("p", Object.assign({ className: "scenario-subheader" }, { children: scenario.subHeader })), _jsx("ul", Object.assign({ className: "scenario-nested-list" }, { children: scenario.items.map((item, idx) => (_jsxs("li", Object.assign({ className: "scenario-nested-item" }, { children: [item.text, item.subText && (_jsx("p", Object.assign({ className: "scenario-subtext" }, { children: item.subText })))] }), idx))) }))] }), index))) }) }), _jsx(Stack.Item, { children: _jsxs(Stack, Object.assign({ horizontal: true, tokens: { childrenGap: 10 }, styles: { root: { marginTop: "-5px" } } }, { children: [_jsx(Stack.Item, Object.assign({ styles: { root: { paddingTop: "0px" } } }, { children: _jsx(Text, { children: getLocalSpecificString("vlm365AzureCompletedResearchText") }) })), _jsx(Stack.Item, { children: _jsx(Checkbox, { required: true, onChange: (event, value) => {
                                                    setEnableEscalationButton(value);
                                                }, ariaLabel: getLocalSpecificString("vlm365AzureCompletedResearchText"), styles: { root: { paddingTop: "0px" } } }) })] })) })] })) })), _jsx(Stack.Item, { children: _jsxs(Stack, Object.assign({ horizontal: true, tokens: { childrenGap: 10 }, className: "customFooter", wrap: true }, { children: [_jsx(Stack.Item, Object.assign({ align: "center" }, { children: _jsx(ElxPrimaryButton, { text: "Continue with submission of GetHelp", disabled: !enableEscalationButton, onClick: onCreateEscalationClick }) })), _jsx(Stack.Item, Object.assign({ align: "center" }, { children: _jsx(ElxSecondaryButton, { text: "Cancel", onClick: onCancel }) }))] })) })] })) })));
};
